
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recs",
      function () {
        return require("private-next-pages/recs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recs"])
      });
    }
  